import { handleActions } from "redux-actions";

import {
  FETCH_MODULES_SUCCESS,
  DELETE_MODULE_SUCCESS,
  EDIT_MODULE_SUCCESS,
  CHANGE_PREVIEW_CHART_TYPE,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_PREVIEW_CHART_SUCCESS,
  SET_CATEGORY,
  FETCH_EDIT_PREVIEW_SUCCESS,
  RESET_PREVIEW,
  SET_STATUS,
  SET_CATEGORIES_LOADING,
  SET_ERROR,
  SET_LOADING
} from "./customChartSagas";

export const initialState = {
  isCategoriesLoading: false,
  isLoading: false,
  categories: [],
  previewModalData: {
    selectedCategories: {
      category: null,
      category_target: null,
      compare_category: null,
      compare_category_target: null
    },
    name: "",
    graph_type: "BarChart",
    chart: {
      data_table: { rows: [], columns: [] }
    }
  },
  modules: [],
  status: "idle",
  errors: {}
};

function getSelectedCategories(state, input) {
  const findCategoryById = (id) => state.categories.find((category) => category.id === id) || null;
  const findTargetById = (category, targetId) =>
    category?.targets?.find((target) => target.id === targetId) || null;

  const category = findCategoryById(input.category_id);
  const compareCategory = findCategoryById(input.compare_category_id);

  return {
    category,
    category_target: findTargetById(category, input.category_target_id),
    compare_category: compareCategory,
    compare_category_target: findTargetById(compareCategory, input.compare_category_target_id)
  };
}

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_CATEGORIES_LOADING]: (state, action) => ({
      ...state,
      isCategoriesLoading: action.payload
    }),
    [DELETE_MODULE_SUCCESS]: (state, action) => ({
      ...state,
      modules: state.modules.filter((module) => module.id !== action.payload)
    }),
    [EDIT_MODULE_SUCCESS]: (state, action) => ({
      ...state,
      modules: state.modules.map((module) =>
        module.id === action.payload.id ? action.payload : module
      )
    }),
    [RESET_PREVIEW]: (state) => ({
      ...state,
      previewModalData: {
        ...initialState.previewModalData
      },
      status: "idle",
      errors: null
    }),
    [FETCH_CATEGORIES_SUCCESS]: (state, action) => ({
      ...state,
      categories: action.payload
    }),
    [CHANGE_PREVIEW_CHART_TYPE]: (state, action) => ({
      ...state,
      previewModalData: {
        ...state.previewModalData,
        graph_type: action.payload
      }
    }),
    [FETCH_PREVIEW_CHART_SUCCESS]: (state, action) => ({
      ...state,
      previewModalData: {
        ...state.previewModalData,
        chart: action.payload
      }
    }),
    [SET_CATEGORY]: (state, action) => ({
      ...state,
      previewModalData: {
        ...state.previewModalData,
        selectedCategories: {
          ...state.previewModalData.selectedCategories,
          ...action.payload
        }
      }
    }),
    [FETCH_EDIT_PREVIEW_SUCCESS]: (state, action) => {
      const selectedCategories = getSelectedCategories(state, action.payload);
      const { chart, graph_type } = action.payload;

      return {
        ...state,
        previewModalData: {
          selectedCategories,
          chart,
          graph_type
        }
      };
    },
    [FETCH_MODULES_SUCCESS]: (state, action) => ({
      ...state,
      modules: action.payload
    })
  },
  initialState
);
